export interface BatchHeaderColDef {
  flex: number;
  minWidth: number;
  cellDataType: string;
  field: string;
  headerName: string;
  sortable?: boolean;
  lockPosition?: string;
  checkboxSelection?: boolean;
  valueGetter?: (params: any) => any;
}

export const BatchHeaderColDefs: BatchHeaderColDef[] = [
  {
    flex: 1, minWidth: 20, cellDataType: 'string', field: 'partner', headerName: 'Partner', sortable: false,
    valueGetter: (params) => {
      const partnerValue = params.data?.partner || '';
      return partnerValue.toLowerCase().replace(/\b\w/g, (l: string) => l.toUpperCase());
    }
  },
  {
    flex: 1, minWidth: 80, cellDataType: 'string', field: 'work_type', headerName: 'Batch Type', sortable: true,
    valueGetter: (params) => {
      const val = params.data?.work_type?.toLowerCase() || '';
      const map: Record<string, string> = { movies: 'MOVIE', tv: 'TV' };
      return map[val] ?? val.toUpperCase();
    }
  },
  { flex: 1, minWidth: 250, cellDataType: 'string', field: 'batch_id', headerName: 'Batch ID', sortable: true },
  { flex: 1, minWidth: 50, cellDataType: 'string', field: 'entry_hdr_id', headerName: 'Entry Header ID', sortable: true },
  { flex: 1, minWidth: 50, cellDataType: 'string', field: 'start_time', headerName: 'Start', sortable: true },
  { flex: 1, minWidth: 50, cellDataType: 'string', field: 'end_time', headerName: 'End', sortable: true },
  { flex: 1, minWidth: 60, cellDataType: 'string', field: 'import_step', headerName: 'Import', sortable: true, valueGetter: (params) => params.data?.import_step?.status || 'N/A' },
  { flex: 1, minWidth: 80, cellDataType: 'string', field: 'transformation_step', headerName: 'Transformation', sortable: true, valueGetter: (params) => params.data?.transformation_step?.status || 'N/A' },
  { flex: 1, minWidth: 60, cellDataType: 'string', field: 'transmit_step', headerName: 'Transmit', sortable: true, valueGetter: (params) => params.data?.transmit_step?.status || 'N/A' },
  { flex: 1, minWidth: 50, cellDataType: 'number', field: 'entry_count', headerName: 'Entry Count', sortable: true }

];